/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Vaše e-mailová adresa`
};

const da_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Din e-mailadresse`
};

const de_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Ihre E-Mail-Adresse`
};

const en_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Your email address`
};

const es_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Su dirección de correo electrónico`
};

const fr_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Votre adresse email`
};

const hu_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Az Ön e-mail címe`
};

const it_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Il tuo indirizzo e-mail`
};

const nl_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Je e-mailadres`
};

const pl_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Twój adres e-mail`
};

const pt_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `O seu endereço de e-mail`
};

const sv_newsletter_footer_email_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Din e-postadress`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_footer_email_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_footer_email_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_footer_email_placeholder", locale)
	if (locale === "cs") return cs_newsletter_footer_email_placeholder(inputs)
	if (locale === "da") return da_newsletter_footer_email_placeholder(inputs)
	if (locale === "de") return de_newsletter_footer_email_placeholder(inputs)
	if (locale === "en") return en_newsletter_footer_email_placeholder(inputs)
	if (locale === "es") return es_newsletter_footer_email_placeholder(inputs)
	if (locale === "fr") return fr_newsletter_footer_email_placeholder(inputs)
	if (locale === "hu") return hu_newsletter_footer_email_placeholder(inputs)
	if (locale === "it") return it_newsletter_footer_email_placeholder(inputs)
	if (locale === "nl") return nl_newsletter_footer_email_placeholder(inputs)
	if (locale === "pl") return pl_newsletter_footer_email_placeholder(inputs)
	if (locale === "pt") return pt_newsletter_footer_email_placeholder(inputs)
	return sv_newsletter_footer_email_placeholder(inputs)
};
export { newsletter_footer_email_placeholder as "newsletter.footer.email_placeholder" }